export default __webpack_public_path__ + "static/media/alumni.55d06143.svg";